// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__wZ09k","modalFooterButton":"ModalNotes_modalFooterButton__17BP4"};